import {cx} from "emotion";
import * as React from "react";

import "./image-viewer.scss";

import {cs}         from "@Common/react/chain-services";
import {UseState}   from "@Common/react/use-state";
import {Responsive} from "@Common/ui-components/responsive";
import {chain}      from "@Common/utils/fs";

const maxThumbnailCount = 5;
export const ImageViewer = ({images, onEnlarge, viewing, loading, state=null, templateBacks=null}) => cs(
    ["hovered", (_, next) => UseState({next})],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ({responsive}) => (
        responsive.lt("mobile") ? (
            <div className="image-viewer image-viewer-k4t">
                <div className="large">
                    {chain(
                        images?.find((img, i) => i === viewing),
                        // hovered.value ?? images.find((img) => img.selected),
                        (img) => <>
                            <div className="img">
                                <img {...{
                                    src: loading ? (
                                        require("../../../../../../common/loading_pdf.gif")
                                    ) : !img ? (
                                        "assets/NoImageAvailable.png"
                                    ) : (
                                        img.src
                                    ),
                                }}
                                    alt={"Image " + (viewing + 1)}
                                    xd-qa-type="Image"
                                    xd-qa-name={"Image " + (viewing + 1)}
                                />
                            </div>
                        </>
                    )}
                </div>
                {images?.length > 1 && frontThumbnails(images, state, templateBacks, viewing, onEnlarge)}
            </div>
        ) : (
            <div className="image-viewer image-viewer-k4t">
                <div className="large" onClick={onEnlarge} xd-qa-type="button" xd-qa-name="Click to Enlarge">
                    {chain(
                        images?.find((img, i) => i === viewing),
                        // hovered.value ?? images.find((img) => img.selected),
                        (img) => <>
                            <div className="img">
                                <img {...{
                                    src: loading ? (
                                        require("../../../../../../common/loading_pdf.gif")
                                    ) : !img ? (
                                        "assets/NoImageAvailable.png"
                                    ) : (
                                        img.src
                                    ),
                                }}
                                    alt={"Image " + (viewing + 1)}
                                    xd-qa-type="Image"
                                    xd-qa-name={"Image " + (viewing + 1)}
                                />
                            </div>
                        </>
                    )}

                </div>
                {images?.length > 1 && frontThumbnails(images, state, templateBacks, viewing, onEnlarge)}
            </div>
        )
    ),
);

const frontThumbnails = (images, state, templateBacks, viewing, onEnlarge) => (
    <div className="thumbnails">
        {chain(
            images?.length <= maxThumbnailCount ? {
                images,
                moreCount: 0,
                firstHiddenImage: null,
            } : {
                images: images?.slice(0, maxThumbnailCount - 1),
                moreCount: images?.length - (maxThumbnailCount - 1),
                firstHiddenImage: images?.[maxThumbnailCount - 1],
            },
            ({images, moreCount, firstHiddenImage}) => <>
                {images?.map((img, i) => (
                    <div className="img-container" key={i}>
                        {images.length > 1 && i === viewing && (
                            <div className="highlight"/>
                        )}
                        <div
                            key={i}
                            className={cx("img", {frontTemplate: images.length > 1 && i === viewing})}
                            style={{backgroundImage: `url('${img.src}')`}}
                            onClick={() => img.onClick()}
                            xd-qa-type="icon"
                            xd-qa-name={"Image " + (i+1)}
                        >
                            {img.selected && (
                                <div className="check">
                                    <i className="fa fa-check"/>
                                </div>
                            )}
                        </div>

                    </div>
                ))}
                {moreCount > 0 && (
                    <a
                        className="more"
                        onClick={() => {
                            firstHiddenImage.onClick();
                            onEnlarge();
                        }}
                        xd-qa-type="button"
                        xd-qa-name="Click to Enlarge"
                    >
                        <span className="text">+{moreCount} more</span>
                    </a>
                )}
            </>,
        )}
        {templateBacks && templateBacks?.length > 1 && state?.value && !state.value.changeBackOverride && <a
            className="changeBackTemplate"
            onClick={() => {
                state.onChange( {...state.value, changeBackOverride: state.value.itemThumbnails} );
                window.scrollTo({
                    top: (
                        document.getElementById(`component-${state.value.sku.front}`).getBoundingClientRect().top - 50
                    ),
                    behavior:"smooth",
                })
            }}
            xd-qa-type="button"
            xd-qa-name="Change Back Template"
        >
            Change Back Template
        </a>}
    </div>
);

